import React, { useState, useEffect } from "react";
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";
import { Card, CardHeader, Container, Row } from "reactstrap";
import {
  APP_GUIDE_API,
  DELETE_APP_GUIDE_API,
  UPDATE_APP_GUIDE_API,
} from "../../../services/CONSTANTS";
import {
  getApiDataService,
  deleteApiDataService,
  putApiDataService,
  postApiDataService,
  postApiImageUploadService,
} from "../../../services/apiServices";
import { ConfirmDialog, DataTable, FilterBar, StatusBadge } from "components/shared";
import CreateAppGuideModal from "./CreateAppGuideModal";
import EditAppGuideModal from "./EditAppGuideModal";

const COLUMNS = [
  { key: "index", label: "#" },
  { key: "thumbnail", label: "Thumbnail" },
  { key: "title", label: "Title" },
  { key: "url", label: "URL (link)" },
  { key: "status", label: "Status" },
  { key: "spacer", label: "" },
  { key: "actions", label: "" },
];

function AppGuide() {
  const history = useHistory();
  const [announcement, setannouncement] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [item, setitem] = useState(null);

  useEffect(() => {
    fetchAppGuide();
  }, []);

  const handleCreateClick = () => {
    console.log("Create item");
    setShowCreateModal(true);
  };

  const handleDeleteClick = (item) => {
    console.log("Delete item", item);
    setitem(item);
    setShowDeleteModal(true);
  };

  const handleEditClick = (item) => {
    console.log("Edit item", item);
    setitem(item);
    setShowEditModal(true);
  };

  const fetchAppGuide = () => {
    setIsLoading(true);
    getApiDataService(APP_GUIDE_API)
      .then((res) => {
        setannouncement(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setannouncement([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  const handleDeleteConfirm = () => {
    setIsLoading(true);
    console.log("Deleting item", item.id);
    deleteApiDataService(DELETE_APP_GUIDE_API(item.id))
      .then((res) => {
        console.log("Delete success", res);
        setShowDeleteModal(false);
        fetchAppGuide();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in delete!", err);
        setIsLoading(false);
      });
  };

  const handleModalBoxCancel = () => {
    setShowDeleteModal(false);
    setShowEditModal(false);
    setShowCreateModal(false);
  };

  const handleUpdateSubmit = (data) => {
    console.log("data", data);
    setIsLoading(true);
    putApiDataService(UPDATE_APP_GUIDE_API(item?.id), data)
      .then((res) => {
        console.log(res);
        setIsLoading(false);
        setShowEditModal(false);
        fetchAppGuide();
      })
      .catch((err) => {
        console.log("Error in handleUpdateSubmit!", err);
        setIsLoading(false);
      });
  };

  const handleCreateSubmit = (data) => {
    console.log("data", data);
    setIsLoading(true);
    postApiImageUploadService(APP_GUIDE_API, data)
      .then((res) => {
        console.log(res);
        setIsLoading(false);
        setShowCreateModal(false);
        fetchAppGuide();
      })
      .catch((err) => {
        console.log("Error in handleCreateSubmit!", err);
        setIsLoading(false);
      });
  };
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <FilterBar title="App Guide">
                  <button
                    onClick={() => handleCreateClick()}
                    className="btn btn-sm btn-primary"
                  >
                    Create
                  </button>
                </FilterBar>
              </CardHeader>
              <DataTable
                className="table-striped"
                columns={COLUMNS}
                data={announcement}
                isLoading={isLoading}
                emptyMessage="No records found"
                renderRow={(item, index) => (
                  <tr key={item?.id ?? index}>
                    <th>{index + 1}</th>
                    <td>
                      <img
                        alt={item?.title || "App guide thumbnail"}
                        src={item?.thumbnail}
                        style={{ width: "150px" }}
                      />
                    </td>
                    <th scope="row">
                      <p>{item?.title}</p>
                    </th>
                    <td>
                      <a href={item?.streaming_url} target="blank">
                        {item?.streaming_url}
                      </a>
                    </td>
                    <td>
                      <StatusBadge status={item?.status} />
                    </td>
                    <td></td>
                    <td className="text-right">
                      <div className="row">
                        <div className="col">
                          <button
                            className="btn btn-outline-success btn-sm"
                            onClick={() => handleEditClick(item)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(item)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              />
            </Card>
          </div>
        </Row>
      </Container>
      {showDeleteModal && (
        <ConfirmDialog
          isOpen
          toggle={handleModalBoxCancel}
          title="Delete"
          message="Are you sure you want to delete this item?"
          confirmText="Yes"
          confirmColor="danger"
          isLoading={isLoading}
          onConfirm={handleDeleteConfirm}
        />
      )}
      {showEditModal && (
        <EditAppGuideModal
          item={item}
          onClose={handleModalBoxCancel}
          onSubmit={handleUpdateSubmit}
          isLoading={isLoading}
        />
      )}
      {showCreateModal && (
        <CreateAppGuideModal
          onClose={handleModalBoxCancel}
          onSubmit={handleCreateSubmit}
          isLoading={isLoading}
        />
      )}
    </>
  );
}

export default AppGuide;
